import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../../base-template-editor/template-editor.component';
import { UniqueTextConstraint } from '../../../../../models/template/unique-text-constraint.interface';
import { RequiredFieldConstraint } from '../../../../../models/template/required-field-constraint.interface';

@Component({
    selector: 'app-gen-video-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/gen-video-template/"
      channelLabel="Google Demand Gen Video"
      namePlaceholder="Enter Google Demand Gen Video template name"
      emptyMessage="No Google Demand Gen Video found!"
      heartbeatType="gen-video-template"
      [showSidePreview]="true"
      [defaultBlocks]="defaultBlocks"
      [uniqueTextConstraints]="uniqueTextConstraints"
      [requiredFields]="requiredFields"
      />
  `
})
export class GenVideoTemplateComponent {
  protected readonly templateType = TypeEnum.GOOGLE_GEN_VIDEO;

  protected readonly uniqueTextConstraints: UniqueTextConstraint[] = [
    { blockName: 'gen-video-long-headline', fields: ['GenVideoLongHeadline_'] },
    { blockName: 'gen-video-headline', fields: ['GenVideoHeadline_'] },
    { blockName: 'gen-video-description', fields: ['GenVideoDescription_'] },
    { blockName: 'gen-video-youtube-url', fields: ['GenVideoYoutubeUrl_'] },
  ];

  // The CTA is a dropdown, which the empty-field check on save cannot see.
  protected readonly requiredFields: RequiredFieldConstraint[] = [
    { blockName: 'gen-video-cta-text', field: 'Text', label: 'CTA' },
  ];

  // Order matters — it is the order the blocks are laid out in the editor.
  // `count` sets the starting instance index.
  // Seed only the minimum: the list blocks add a variable when the author fills
  // one in, so extra keys here would just be saved as empty strings.
  protected readonly defaultBlocks: { name: string; count?: number; variables: Record<string, string> }[] = [
    { name: 'gen-video-long-headline', count: 1, variables: { GenVideoLongHeadline_1: '' } },
    { name: 'gen-video-headline', count: 1, variables: { GenVideoHeadline_1: '' } },
    { name: 'gen-video-description', count: 1, variables: { GenVideoDescription_1: '' } },
    { name: 'gen-video-youtube-url', count: 1, variables: { GenVideoYoutubeUrl_1: '', GenVideoYoutubeUrl_2: '', GenVideoYoutubeUrl_3: '' } },
    { name: 'gen-video-url', count: 1, variables: { Link: '' } },
    { name: 'gen-video-cta-text', count: 1, variables: { Text: '' } },
  ];
}
